import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../../../../../redux/connect';
import { openAttachmentAction, showAttachmentsInGallery } from '../../../../../../../redux/actions';
import { getThumbnailUrlByAttachment, isLoadingThumbnails } from '../../../../../../../redux/selectors';
import downloadAttachmentThunk from '../../../../../../../redux/thunk/attachmentDownloadThunk';
import ChannelItemBase from '../../../../../../ChannelItemBase';
import T from 'i18n-react';
import { toLocalDateTime } from '../../../../../../../utils/date-helpers';
import { OSS_URN_TYPE } from '../../../../../../../constants/attachment-types';
import { isImageAttachment } from '../../../../../../../utils/attachmentsHelper';
import { attachmentAttributesType } from '../../../../../../../constants/proptype-validation/attachment-proptypes';
import { Text } from '@adsk/bim360-matrix-react-components';
import ChangesetThumbnail from '../../../../../../ChangesetThumbnail';
import classNames from 'classnames';
import { trimFileName } from '../../../../../../../utils/notificationHelpers';
import TryAgainErrorNotification from '../../../../../../../components/TryAgainErrorNotification';

// global URL
export class PureAttachmentDetails extends ChannelItemBase {

  constructor() {
    super();
    this.downloadAttachment = this.downloadAttachment.bind(this);
    this.openAttachment = this.openAttachment.bind(this);
  }

  openAttachment(e) {
    e.preventDefault();
    const { attachment, openAttachmentAction } = this.props;
    openAttachmentAction(attachment);
  }


  downloadAttachment() {
    const { attachment, downloadAttachment } = this.props;
    const trimmedFileName = trimFileName(attachment.name, 35);
    const failureMessage = <TryAgainErrorNotification message={T.translate('notifications.failedToDownload', { fileName: trimmedFileName })} tryAgainAction={() => this.downloadAttachment()} />;
    const asyncMessage = <Text hasHTML>{T.translate('notifications.preparingToDownload', { fileName: trimmedFileName })}</Text>;

    downloadAttachment(attachment, asyncMessage, failureMessage);
  }

  linkToAttachment() {
    const { attachment, thumbnailUrl, showAttachmentsInGallery, isLoadingThumbnails } = this.props;
    const { urnType, deletedAt } = attachment;
    let handleAttachmentClick;

    if (!deletedAt) {
      const isImageFile = isImageAttachment(attachment);

      if (urnType === OSS_URN_TYPE) {
        if (isImageFile) {
          handleAttachmentClick = () => { showAttachmentsInGallery([attachment]); };
        } else {
          handleAttachmentClick = this.downloadAttachment;
        }
      } else {
        handleAttachmentClick = this.openAttachment;
      }
    }

    const classes = classNames('isui-attachment__photo', {
      'isui-attachment__photo--disabled': !handleAttachmentClick,
    });

    return (
      <div className={classes} onClick={handleAttachmentClick}>
        <ChangesetThumbnail isLoading={isLoadingThumbnails} thumbnailUrl={deletedAt ? null : thumbnailUrl} />
      </div>
    );
  }

  render() {
    const { attachment } = this.props;
    const { createdAt, deletedAt, createdByDisplayName, deletedByDisplayName, name, isDeleteAttachmentChange } = attachment;
    let actorName;
    let changeTime;
    let changeText;
    if (isDeleteAttachmentChange) {
      actorName = deletedByDisplayName;
      changeTime = deletedAt;
      changeText = T.translate('changeset.deletedAttachment');
    } else {
      actorName = createdByDisplayName;
      changeTime = createdAt;
      changeText = T.translate('changeset.addedAttachment');
    }

    return (
      <div>
        <header className="isui-channel-item__header">
          <span className="isui-channel-item__name">{actorName || T.translate('userUndefined')}</span>
          <span className="isui-channel-item__timestamp">{toLocalDateTime(changeTime)}</span>
        </header>
        <div className="isui-channel-item__body--attachment">
          {this.linkToAttachment()}
          <div>
            <Text ellipsis>{name}</Text>
            <Text ellipsis>{changeText}</Text>
          </div>
        </div>
      </div>
    );
  }
}

PureAttachmentDetails.displayName = 'AttachmentDetails';

PureAttachmentDetails.propTypes = {
  attachment: attachmentAttributesType.isRequired,
  thumbnailUrl: PropTypes.string,
  openAttachmentAction: PropTypes.func.isRequired,
  downloadAttachment: PropTypes.func.isRequired,
  showAttachmentsInGallery: PropTypes.func.isRequired,
  isLoadingThumbnails: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  thumbnailUrl: getThumbnailUrlByAttachment(state, ownProps.attachment),
  isLoadingThumbnails: isLoadingThumbnails(state),
});

const mapDispatchToProps = {
  openAttachmentAction,
  downloadAttachment: downloadAttachmentThunk.downloadAttachment,
  showAttachmentsInGallery,
};

export default connect(mapStateToProps, mapDispatchToProps)(PureAttachmentDetails);

